import { RequestsPage } from '@/pages/RequestsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/requests/')({
  component: RequestsPage,
})
